/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/07/2024 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Agrega limpieza de pantalla a acciones
* ---------------------------------------------------------------------------------------
*/

import { IconButton, Tooltip } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import { Fragment } from "react";
import { useVentas } from "../../context/Ventas/VentasContext";

export default function MnuVerificadorActions({ onOpenBuscador, onLimpiarPantalla, onWhatsApp }) {
  const {
    handleClickRegresarMainDashboard,
  } = useVentas();

  return (
    <Fragment>
      <Tooltip title={"Home"}>
        <IconButton onClick={handleClickRegresarMainDashboard}>
          <HomeIcon className="icon" /><p className="icon"> Salir</p>
        </IconButton>
      </Tooltip>

      <Tooltip title={"Buscar (Alt+F1)"}>
        <IconButton onClick={() => onOpenBuscador && onOpenBuscador()}>
          <SearchIcon className="icon" /><p className="icon">Buscar</p>
        </IconButton>
      </Tooltip>

      <Tooltip title={"Limpiar pantalla"}>
        <IconButton onClick={() => onLimpiarPantalla && onLimpiarPantalla()}>
          <CleaningServicesIcon className="icon" /><p className="icon">Limpiar</p>
        </IconButton>
      </Tooltip>

      <Tooltip title={"Enviar por WhatsApp"}>
        <span>
          <IconButton
            onClick={() => onWhatsApp && onWhatsApp()}
            disabled={!onWhatsApp}
            sx={{ color: '#25D366' }}
          >
            <WhatsAppIcon className="icon" /><p className="icon">WhatsApp</p>
          </IconButton>
        </span>
      </Tooltip>
    </Fragment>
  );
}
